module.exports = __webpack_public_path__ + "assets/media/linkedInIcon.9084497b.svg";